module.exports = __webpack_public_path__ + "img/securityBanner.6f607941.png";